import { first } from 'rxjs/operators';
import * as Configuration from '../../../app.constants.js';

AddAccountFbOldController.$inject = ['$scope', '$http', 'TopToolbarFactory', '$stateParams', 'company', 'AlertingFactory', 'LoginFactory'];
export function AddAccountFbOldController($scope, $http, TopToolbarFactory, $stateParams, company, AlertingFactory, LoginFactory) {
  init();

  function getData() {
    let data = {
      request_id: $stateParams.requestId || null,
      site_id: $stateParams.siteId || null,
      code: $stateParams.code || null
    };
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' +
      company.id + '/fb/authorized/data';
    $http.post(url, data)
      .then(function success(response) {
        if(response.data.reauth) {
          LoginFactory.redirectWithJwtShort(response.data.redirect_url);
        }
        else if(response.data.error) {
          let url = response.data.redirect_url + '?error=' + response.data.reason;
          LoginFactory.redirectWithJwtShort(url);
        }
        else {
          $scope.pages = response.data.pages;
          $scope.add_page_url = response.data.add_page_url;
          // Will be valid 10 min, which seems enough to click a radio button and submit
          // More cleanly, should be done when submitting, but need some refactoring, and so, should be migrated in angular
          LoginFactory.getJwtShort()
            .pipe(first())
            .subscribe(jwt => {
              $scope.jwt = jwt;
              $scope.isLoading = false;
            });
        }
      }, function error(response) {
        AlertingFactory.alertHTTPError(response);
      });
  }

  function init() {
    TopToolbarFactory.setTitle('Connect a Facebook Page with Alcmeon', $scope);
    $scope.isLoading = true;
    getData();
  }
}
